import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import { Observable, Subscriber, from } from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  constructor(private http: HttpClient,
    private domSanitizer: DomSanitizer) {
}

uploadFileS3(file: File, signedUrl: string, type: string): Observable<any> {
  return new Observable((observer: Subscriber<any>) => {
    const reader: any = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.addEventListener('loadend', async (ev: any) => {
      try {
        const response = await fetch(signedUrl, {
          method: 'PUT',
          body: new Blob([reader.result], {type})
        });
        const text = await response.text();
        if (!response.ok) {
          throw text;
        }
        observer.next('ok');
        observer.complete();
      } catch (e) {
        observer.error(e);
      }
    });
  });
}

getSignedUrl(data: any): Observable<any> {
  const body = JSON.stringify(data);
  const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
  return this.http.post(`${environment.API_DOMAINS.servicios}/getSignedUrl`, body, {headers});
}

guardarDocumentos(data: any): Observable<any> {
  const body = JSON.stringify(data);
  const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
  return this.http.post(`${environment.API_DOMAINS.servicios}/denuncias/guardarDocumentos`, body, {headers});
}
}
